function parseFiniteNumber (value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const number = Number(value)
  if (Number.isNaN(number) || !Number.isFinite(number)) {
    return null
  }

  return number
}

function calculateEstimatedArrivalMinutes ({ distanceKm, speedKmPerHour } = {}) {
  const distance = parseFiniteNumber(distanceKm)
  const speed = parseFiniteNumber(speedKmPerHour)

  if (distance === null || speed === null || distance < 0 || speed <= 0) {
    return null
  }

  return (distance / speed) * 60
}

function formatMinutesAsHoursAndMinutes (totalMinutes) {
  const minutes = parseFiniteNumber(totalMinutes)
  if (minutes === null || minutes < 0) {
    return ''
  }

  const minutesInt = Math.round(minutes)

  if (minutesInt < 60) {
    return minutesInt + ' min' + (minutesInt === 1 ? '' : 's')
  }

  const hours = Math.floor(minutesInt / 60)
  const remainingMinutes = minutesInt % 60
  const parts = []

  parts.push(hours > 2 ? 'over 2hrs' : (hours + ' hr' + (hours === 1 ? '' : 's')))

  if (remainingMinutes > 0) {
    parts.push(remainingMinutes + ' min' + (remainingMinutes === 1 ? '' : 's'))
  }

  return parts.join(' ')
}

function formatDistanceKm (distanceKm) {
  const distance = parseFiniteNumber(distanceKm)
  if (distance === null || distance < 0) {
    return ''
  }

  return (Math.round(distance * 1000) / 1000) + ' km'
}

function resolveEstimatedArrivalLabel ({ distanceKm, speedKmPerHour } = {}) {
  const minutes = calculateEstimatedArrivalMinutes({
    distanceKm,
    speedKmPerHour
  })

  return formatMinutesAsHoursAndMinutes(minutes)
}

module.exports = {
  calculateEstimatedArrivalMinutes,
  formatDistanceKm,
  formatMinutesAsHoursAndMinutes,
  resolveEstimatedArrivalLabel
}
